/* eslint-disable @typescript-eslint/no-empty-interface */
import { Table } from 'components/common/Table/Table';
import * as S from './Answer.styles';
import { useSelector } from 'react-redux';
import { RootState } from '@app/store/store';
import { useEffect, useState } from 'react';
import { practiceScore } from '@app/api/academic.api';
import { notificationController } from '@app/controllers/notificationController';
import { Spin } from 'antd';

interface AnswerProps {
  showAnswer: boolean;
  questionId: string;
  answer: string;
}
export const Answer: React.FC<AnswerProps> = ({ showAnswer, questionId, answer }) => {
  const { timePractice } = useSelector((state: RootState) => state.exam);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showAnswer) {
      fetchPracticeScore();
    }
  }, [showAnswer]);

  const fetchPracticeScore = async () => {
    // if (!audioBlod) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('questionId', questionId);
      formData.append('answer', answer);
      formData.append('time', timePractice.toString());
      const res = await practiceScore(formData);

      if (res.statusCode === 200) {
        notificationController.success({ message: res.message });
      }
    } catch (error) {
      console.error(error);
      notificationController.error({ message: 'Xảy ra lỗi. Vui lòng thử lại sau' });
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center">
        <Spin />
      </div>
    );
  return (
    // <S.CardAnswer>
    //   <S.CardAnswerHead>
    //     <S.Title level={5}>Scoring Results</S.Title>
    //   </S.CardAnswerHead>
    //   <S.CardAnswerBody>
    //     <Table columns={columns} scroll={{ x: 800 }} dataSource={data} pagination={false} />
    //   </S.CardAnswerBody>
    // </S.CardAnswer>
    <></>
  );
};
